import React, { useState } from "react";
import { Button } from "primereact/button";
import { useHasRole } from "../../hooks/useHasRole";
import ThgPricesDialog from "./ThgPricesDialog";

interface ThgPricesButtonProps {
  /** Re-runs the page's data after a price was saved. */
  onSaved: () => void;
}

/** CLR-296 opens the THG prices dialog. Admins only: the prices drive money figures and payouts. */
const ThgPricesButton: React.FC<ThgPricesButtonProps> = ({ onSaved }) => {
  const isAdmin = useHasRole("admin");
  const [open, setOpen] = useState(false);
  if (!isAdmin) return null;
  return (
    <>
      <Button label="THG prices" icon="pi pi-euro" outlined onClick={() => setOpen(true)} />
      <ThgPricesDialog visible={open} onHide={() => setOpen(false)} onSaved={onSaved} />
    </>
  );
};

export default ThgPricesButton;
